module.exports = __webpack_public_path__ + "img/pd-img-face7.3d8abe07.png";